import { AvatarCurrency } from '../Avatar/AvatarCurrency';
import { AvatarName } from '../Avatar/AvatarName';
import { useMemo } from 'react';
import { formatIbanForDisplay } from '@razz-team/utils';
import { ListItem, ListItemAvatar, ListItemProps, ListItemText } from '@mui/material';
import { AvatarBadge } from '../Avatar/AvatarBadge';

export interface IndividualBeneficiaryListItemContentProps {
  currency: string;
  displayName?: string | null | undefined;
  individualName: string;
  accountNumber: string;
}

const BADGE_SIZE = 16;

export function IndividualBeneficiaryListItemContent({
  currency,
  displayName,
  individualName,
  accountNumber,
}: IndividualBeneficiaryListItemProps) {
  const name = displayName ?? individualName;
  const iban = useMemo(() => formatIbanForDisplay(accountNumber), [accountNumber]);

  return (
    <>
      <ListItemAvatar>
        <AvatarBadge type="icon" icon={<AvatarCurrency currency={currency} size={BADGE_SIZE} />}>
          <AvatarName name={name} />
        </AvatarBadge>
      </ListItemAvatar>
      <ListItemText primary={`${name} · ${currency}`} secondary={iban} />
    </>
  );
}

export type IndividualBeneficiaryListItemProps = ListItemProps<
  'li',
  IndividualBeneficiaryListItemContentProps
>;

export function IndividualBeneficiaryListItem({
  currency,
  displayName,
  individualName,
  accountNumber,
  ...props
}: IndividualBeneficiaryListItemProps) {
  return (
    <ListItem {...props}>
      <IndividualBeneficiaryListItemContent
        currency={currency}
        displayName={displayName}
        individualName={individualName}
        accountNumber={accountNumber}
      />
    </ListItem>
  );
}
